import { useCallback, useEffect, useRef, useState } from 'react';
import { apiError } from '../../Documents/format';
import { isCancelled, timesheetApi } from '../timesheetApi';
import { TimesheetSummary } from '../types';

/** Сводка по аптекам зоны оператора: загружается при входе и по команде reload (после создания табеля, сверки, смены папки) */
export function useTimesheetSummary(enabled: boolean) {
  const [summary, setSummary] = useState<TimesheetSummary | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);
  const seq = useRef(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const current = ++seq.current;
    const controller = new AbortController();

    timesheetApi
      .summary(controller.signal)
      .then(data => {
        if (current !== seq.current) return;
        setSummary(data);
        setError(null);
      })
      .catch(err => {
        if (isCancelled(err) || current !== seq.current) return;
        setError(apiError(err, 'Не удалось загрузить сводку'));
      });

    return () => controller.abort();
  }, [enabled, reloadToken]);

  const reload = useCallback(() => setReloadToken(t => t + 1), []);

  return { summary, error, reload };
}
